/**
 * button store 模块
 * 管理导航菜单、快捷入口、底部链接、社交图标的状态
 */

const state = {
  // 导航菜单
  navList: [],
  // 快捷入口
  quickEntryList: [],
  // 底部链接
  footerLinkList: [],
  // 社交图标
  socialIconList: [],
  // 加载状态
  loading: false,
  // 已加载过的类型
  _fetched: {}
}

const mutations = {
  SET_NAV_LIST(state, list) {
    state.navList = list
  },
  SET_QUICK_ENTRY_LIST(state, list) {
    state.quickEntryList = list
  },
  SET_FOOTER_LINK_LIST(state, list) {
    state.footerLinkList = list
  },
  SET_SOCIAL_ICON_LIST(state, list) {
    state.socialIconList = list
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}

const actions = {
  /**
   * 获取按钮/链接列表（通用接口）
   * @param {string} type - 类型: nav(导航), shortcut(快捷入口), footer(底部链接), social(社交图标)
   */
  async fetchButtonList({ commit, state }, type) {
    if (state._fetched[type]) {
      const cached = { nav: state.navList, shortcut: state.quickEntryList, footer: state.footerLinkList, social: state.socialIconList }
      return cached[type] || []
    }
    commit('SET_LOADING', false)
    state._fetched[type] = true
    return []
  },

  /**
   * 初始化所有按钮数据
   */
  async initAllButtons({ dispatch }) {
    await Promise.all([
      dispatch('fetchButtonList', 'nav'),
      dispatch('fetchButtonList', 'shortcut'),
      dispatch('fetchButtonList', 'footer'),
      dispatch('fetchButtonList', 'social')
    ])
  }
}

const getters = {
  navList: state => state.navList,
  quickEntryList: state => state.quickEntryList,
  footerLinkList: state => state.footerLinkList,
  socialIconList: state => state.socialIconList,
  isLoading: state => state.loading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
